/**
 * @title global.js: Wrapper module to combine global.base.js and utilityGlobal (utility1 + utility2)
 * This will NOT be included on Home, Browse & Product pages. But will be included on rest of the pages across site.
 */

define(['utilityGlobal', 'globalBase'], function(util, Global) {
  if (typeof window.COSTCO == 'undefined') {
      window.COSTCO = {};
    }
    $(document).ready(function() {
      window.COSTCO.Global = Global;
      window.COSTCO.util = util;
      Global.init();
    });
    return Global;
});


// WEBPACK FOOTER //
// ./js/global/global.js